import React from 'react';
import styled from 'styled-components';

const CarouselContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  justify-content: center;
  padding-bottom: 20px;
  margin: 36px auto 0 auto;
  border-bottom: 1px solid ${({ theme }) => theme.colorsNew.increase.dark70};
  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    flex-direction: row;
    width: 100%;
  }
`;

export default CarouselContainer;
